import AlertComponent, { AlertType } from '@spa/components/alert/alert.component';
import React, { ReactElement } from 'react';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';

export interface Props {
  readonly error: string | null;
  readonly editorMode: boolean;
  readonly type: string | null;
  readonly id: string | null;
}

function ErroredComponent({ error, editorMode, type, id }: Props): ReactElement {
  const { formatMessage }: NamespacedIntl = useNamespacedIntl('errored');

  const alertContent = (): ReactElement | string =>
    editorMode ? (
      <div>
        <p>{error}</p>
        <p>ComponentId: {id}</p>
        <p>ComponentType: {type}</p>
      </div>
    ) : (
      formatMessage('alertMessage')
    );

  return (
    <div data-testid="alert">
      <AlertComponent alertType={AlertType.WARNING} content={alertContent()} />
    </div>
  );
}

export default ErroredComponent;
